const CRYPTOS = ["BTC", "ETH"];

export default CRYPTOS;